import Vue from 'vue'
import store from '@/store/'
import router from '@/router/'
import MyPopup from './myPopup.vue'
const Constructor = Vue.extend(MyPopup)
let instance

const myPopup = async({onSuccess, onError,onClose} = {}) => {
    if (typeof beforeCreate == 'function' && !beforeCreate({router, store})) return
    instance = new Constructor({
        propsData: {
            onSuccess,
            onError,
            onClose
        },
        store,
        router
    })
    instance.vm = instance.$mount()
    var deleteNode = document.querySelector('.my_popup')
    if(deleteNode != null) {
        document.querySelector('body').removeChild(deleteNode);
        document.querySelector('body').appendChild(instance.vm.$el) // new一个对象，然后插入body里面
    }else {
        document.querySelector('body').appendChild(instance.vm.$el) // new一个对象，然后插入body里面
    }    

    instance.vm.$data.isShow = true
    return instance.vm
}
export default myPopup